import '@adornis/filter/aspect-schemas/index.js';
import '@nsc/simple-lms/entities/index.js';
import './SmartTeamsAvailability.js';
import './SmartTeamsCompany.js';
import '@nsc/smartteams-shared/db/SmartTeamsCustomer.js';
import './SmartTeamsFieldEngineer.js';
import './SmartTeamsUserProfile.js';
import './SNLookups.js';
import '@nsc/smartteams-shared/db/SmartTeamsAppUser.js';
import '@nsc/smartteams-shared/db/SmartTeamsAppUserGroup.js';
import '../api/index.js';
import { SimpleRolePolicy } from '@adornis/abac/policies/SimpleRolePolicy.js';
import { dangerouslyDisableOldPermissions } from '@adornis/users/db/a-user.js';
import { DefaultLMSPolicy, initLMS } from '@nsc/simple-lms/init.js';
import { SmartTeamsLMSPolicy } from '@nsc/smartteams-shared/access-control/lms-policy.js';

export { LMSAnswerOption, LMSCourse, LMSCourseEnrollment, LMSCoursePage } from '@nsc/simple-lms/entities/index.js';
export { SmartTeamsAvailability } from './SmartTeamsAvailability.js';
export { SmartTeamsPartnerCompany as SmartTeamsCompany } from './SmartTeamsCompany.js';
export { SmartTeamsCustomer } from '@nsc/smartteams-shared/db/SmartTeamsCustomer.js';
export { SmartTeamsFieldEngineer } from './SmartTeamsFieldEngineer.js';
export { SmartTeamsLocation } from '@nsc/smartteams-shared/db/SmartTeamsLocation.js';
export { SmartTeamsUserProfile } from './SmartTeamsUserProfile.js';
export { SNClientOption, SNFieldEngineerOption } from './SNLookups.js';

dangerouslyDisableOldPermissions();
// Register SmartTeams LMS policy with simple-lms module
initLMS({ policies: [SimpleRolePolicy, SmartTeamsLMSPolicy, DefaultLMSPolicy] });
